/**
 * 총도달 — 글 하나의 조회와 반응을 합친 값. 위클리 브랜드 카드의 「총도달」과 정렬 「총도달」이 같은 값(`metricScore`)을 쓴다.
 *
 * 🔑 저장값 `metricScore` 를 먼저 읽고, 없으면 최근 지표의 좋아요+댓글+조회로 센다(`getPopularityScore`).
 * ⚠️ 정렬 스냅샷(`metricScoreSort`)은 읽지 않는다 — 카드에 적는 값은 지금 저장된 총도달이다.
 * ⚠️ 인스타 글은 루트 `viewCount` 가 거의 비어 있다 — 조회만으로 성과를 세면 대부분 0 이 된다.
 */

import type { SocialPostInput } from 'src/utils/moments/domain/social-post-input';

import { getPopularityScore } from './popularity-score';

/** 화면·툴팁에 적는 셈 */
export const TOTAL_REACH_FORMULA = '조회와 반응 합산';

/**
 * 글 하나의 총도달. 리포스트·수치 없음·음수는 0.
 * @returns 0 이상
 */
export function postTotalReach(post: SocialPostInput | Record<string, unknown> | null | undefined): number {
  const value = Number(getPopularityScore(post as SocialPostInput | null | undefined, { useMetricScoreSort: false }));
  return Number.isFinite(value) && value > 0 ? value : 0;
}
